/**
 * Sticky-стан шапки при скролі.
 *
 * Header завжди `position: fixed` (граблі №29/33), тому тут НЕ перемикаємо
 * position — лише додаємо/знімаємо клас `.is-scrolled`, який вмикає
 * компактний вигляд + slide-down анімацію (_header.scss).
 *
 * Поріг 150px (як у референсі): нижче — шапка "велика" й прозора, вище —
 * компактна з тінню/блюром. Малий поріг (8px) робив анімацію непомітною,
 * бо вона спрацьовувала одразу від найменшого руху.
 */
const SCROLL_THRESHOLD = 150;

export default function fixedHeader() {
	const header = document.querySelector('.site-header');
	if (!header) {
		return;
	}

	const onScroll = () => {
		header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
	};

	onScroll();
	window.addEventListener('scroll', onScroll, { passive: true });
}
